import React from 'react';
import { DateLocal, DateType } from '../DateLocal/DateLocal';
import { Field } from './FormPage';

interface DateFieldProps {
  label: string;
  value?: Date;
  onChange: (date: Date) => void;
  max?: Date;
}

/** Выбор даты в едином стиле форм. */
export const DateField: React.FC<DateFieldProps> = ({ label, value, onChange, max = new Date() }) => (
  <Field label={label}>
    <div className="form-page__date">
      <DateLocal
        onChange={(date) => date && onChange(date)}
        type={DateType.date}
        value={value ?? new Date()}
        max={max}
        width={200}
        isClearable={false}
      />
    </div>
  </Field>
);
